import React, { useState } from "react";
import Swal from "sweetalert2";
import { BookCallService } from "../../services/BookCallService";
import Loader from "../Common/Loader";

const BookCallForm = (props) => {
  const { submitBtnClass, btnText } = props;
  const [isLoading, setLoading] = useState(false);
  const [input, setInput] = useState({
    date: "",
    time: "",
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    notes: "",
  });

  const submit = () => {
    if (
      input.date &&
      input.time &&
      input.name &&
      input.email &&
      input.phone &&
      input.address &&
      input.city &&
      input.state
    ) {
      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(input.email)) {
        Swal.fire({
          title: "Validation Failed!",
          text: "Invalid email address",
          icon: "error",
        });
        return;
      }
      setLoading(true);
      BookCallService.add(input)
        .then((response) => {
          setLoading(false);
          if (response.data.success) {
            Swal.fire({
              title: "Success!",
              text: "Your call has been booked successfully. We will contact you soon!",
              icon: "success",
            });
            setInput({
              date: "",
              time: "",
              name: "",
              email: "",
              phone: "",
              address: "",
              city: "",
              state: "",
              notes: "",
            });
          } else {
            Swal.fire({
              title: "Oops!",
              text: response.data.message,
              icon: "error",
            });
          }
        })
        .catch((ex) => {
          setLoading(false);
          Swal.fire({
            title: "Oops!",
            text: "Something went wrong. Please try again later.",
            icon: "error",
          });
        });
    } else {
      Swal.fire({
        title: "Validation Failed!",
        text: "All fields except notes are required!",
        icon: "error",
      });
    }
  };

  return (
    <div id="book-call-form">
      <div className="row">
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="date"
            id="date"
            name="date"
            value={input.date}
            placeholder="Date"
            required
            onChange={(e) => setInput({ ...input, date: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="time"
            id="time"
            name="time"
            value={input.time}
            placeholder="Time"
            required
            onChange={(e) => setInput({ ...input, time: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="text"
            id="name"
            name="name"
            value={input.name}
            placeholder="Name"
            required
            onChange={(e) => setInput({ ...input, name: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="email"
            id="email"
            name="email"
            value={input.email}
            placeholder="Email"
            required
            onChange={(e) => setInput({ ...input, email: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="text"
            id="phone"
            name="phone"
            value={input.phone}
            placeholder="Phone Number"
            required
            onChange={(e) => setInput({ ...input, phone: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="text"
            id="address"
            name="address"
            value={input.address}
            placeholder="Address"
            required
            onChange={(e) => setInput({ ...input, address: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="text"
            id="city"
            name="city"
            value={input.city}
            placeholder="City"
            required
            onChange={(e) => setInput({ ...input, city: e.target.value })}
          />
        </div>
        <div className="col-md-6 mb-30">
          <input
            className="from-control"
            type="text"
            id="state"
            name="state"
            value={input.state}
            placeholder="State"
            required
            onChange={(e) => setInput({ ...input, state: e.target.value })}
          />
        </div>
        <div className="col-12 mb-30">
          <textarea
            className="from-control"
            id="notes"
            name="notes"
            value={input.notes}
            placeholder="Notes (optional)"
            onChange={(e) => setInput({ ...input, notes: e.target.value })}
          ></textarea>
        </div>
      </div>
      <div className="btn-part">
        <button
          className={submitBtnClass ? submitBtnClass : "readon learn-more submit"}
          type="submit"
          onClick={isLoading ? null : submit}
        >
          {isLoading ? <Loader /> : btnText || "Book Now"}
        </button>
      </div>
    </div>
  );
};

export default BookCallForm; 